import { get, patch, post } from "./base";

const AdminServ = {
  // Get all admins
  getAllAdmins: (params) => get("/admin/admins", { params }),

  // Create admin
  createAdmin: (payload) => post("/admin/admins", payload),

  // Update admin permissions
  updateAdminPermissions: (payload) => patch("/admin/admins/permissions", payload),

  // Update admin basic info
  updateAdmin: (id, payload) => patch(`/admin/admins/${id}`, payload),

  // Dashboard Stats
  getDashboardStats: (params) => get("/admin/dashboard-stats", { params }),

  // Seller Requests
  getAllSellerRequests: (params) => get("/admin/seller-requests", { params }),
  getPendingSellerRequests: () => get("/admin/seller-requests/pending"),
  approveSellerRequest: (payload) => post("/admin/seller-requests/approve", payload),
  rejectSellerRequest: (payload) => post("/admin/seller-requests/reject", payload),
  resendNotification: (payload) => post("/seller-requests/resend-notification", payload),
};

export default AdminServ;
